import { useTranslation } from 'react-i18next'

const FormatProfession = ({ profession }) => {
  const { t } = useTranslation(['translation', 'basic'])
  return t(`basic:b.professions.view.${profession}.text`)
}

export default FormatProfession
